import {Component, EventEmitter, Input, Output} from '@angular/core';

import {Event, EventId} from '../../../models/base/event';

import {Query} from '../../../models/query/query';
import {Criterion} from '../../../models/query/criterion';
import {QueryFields} from '../../../models/ui/query-fields';
import {Entry} from '../../../models/ui/entry';

@Component({
  selector: 'bms-query-criterion',
  templateUrl: './query-criterion-component.html'
})
export class QueryCriterionComponent {

  integerPattern = '^[0-9]+$';
  integerPatterngGeaterThanZero = '^[1-9][0-9]*$';
  realPattern = '^((\\+|-)?([0-9]+)(\\.[0-9]+)?)|((\\+|-)?\\.?[0-9]+)$';
  realPatternTwoDecimal = '[-+]?[0-9]*[.]?([0-9][0-9]?)?';
  realPatternThreeDecimal = '[-+]?[0-9]*[.]?([0-9]{1,3})?';
  zipCodePattern = '[0-9]{5}';
  tinPattern = '[0-9]{9}';
  indCodePattern = '[0-9]{5}';
  idNumberPattern = '[0-9]{8}';
  colorPattern = '[0-9A-Fa-f]+';

  private index: number = 0;

  @Input()
  query: Query;

  @Input('fields')
  fields: QueryFields;

  @Input()
  possibleValues: Entry[];

  fieldName: string = '';
  operator: string = '=';
  type: string = 'string';
  firstValue: any = '';
  secondValue: any = '';

  @Output()
  events: EventEmitter<Event> = new EventEmitter();

  public reset() {
    this.fieldName = '';
    this.operator = '=';
    this.type = 'string';
    this.firstValue = '';
    this.secondValue = '';
  }

  public getCriterion(): Criterion {
    const field = this.fields.get(this.fieldName);
    if (this.operator === Query.EQUAL) {
      return Criterion.equal(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.NOT_EQUAL) {
      return Criterion.notEqual(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.GREATER_THAN) {
      return Criterion.greaterThan(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.GREATER_THAN_OR_EQUAL) {
      return Criterion.greaterThanOrEqual(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.LESS_THAN) {
      return Criterion.lessThan(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.LESS_THAN_OR_EQUAL) {
      return Criterion.lessThanOrEqual(field.alias, this.fieldName, this.firstValue);
    } else if (this.operator === Query.IS_NULL) {
      return Criterion.isNull(field.alias, this.fieldName);
    } else if (this.operator === Query.IS_NOT_NULL) {
      return Criterion.isNotNull(field.alias, this.fieldName);
    } else if (this.operator === Query.LIKE) {
      return Criterion.like(field.alias, this.fieldName, '%' + this.firstValue + '%');
    } else if (this.operator === Query.NOT_LIKE) {
      return Criterion.notLike(field.alias, this.fieldName, '%' + this.firstValue + '%');
    } else if (this.operator === Query.BETWEEN) {
      return Criterion.between(field.alias, this.fieldName, this.firstValue, this.secondValue);
    }else if (this.operator === Query.NOT_BETWEEN) {
      return Criterion.notBetween(field.alias, this.fieldName, this.firstValue, this.secondValue);
    }
  }

  onFieldChange(fieldName: string) {
    const oldType = this.type;
    const field = this.fields.get(fieldName);

    if (field !== undefined && field !== null) {
      this.type = field.type;
    }

    if (oldType !== this.type) {
      this.firstValue = '';
      this.secondValue = '';
    }

    if (this.type === 'select') {
      this.possibleValues = field.possibleValues;
    }
  }

  onOperatorChange(operator: string) {
    if (operator === Query.IS_NULL || operator === Query.IS_NOT_NULL) {
      this.firstValue = '';
      this.secondValue = '';
    }
  }

  isValid(): boolean {
    if (this.operator !== Query.IS_NULL && this.operator !== Query.IS_NOT_NULL) {
      return this.fieldName !== '' && this.operator !== '' && this.firstValue !== '';
    } else {
      return this.fieldName !== '';
    }
  }

  private removeCriterion() {
   this.events.next(new Event(EventId.QUERY_CRITERION_REMOVE, this));
  }
}
